import React from 'react'
import {Hike} from "@code-hike/scrollycoding";
import {PreviewProps} from "@code-hike/scrollycoding/dist/preview";
import {CodeProps} from "@chakra-ui/react";

export interface CodeHikeProps {
  previewProps: PreviewProps;
  codeProps: CodeProps;
}

const classes = {
  'ch-hike-step-content-unfocused': 'opacity-25 transition-opacity',
  'ch-hike-step-content': 'border-none transition-opacity',
  'ch-frame-button': 'bg-gray-300 border-gray-600',
}

const preset = {
  template: 'react' as const,
}

const CodeHike: React.FC<CodeHikeProps> = ({previewProps, codeProps, children, ...props}) => {
  const editorProps = {
    codeProps: {
      minColumns: 40,
      ...codeProps
    },
    ...previewProps,
  }

  return (
    <Hike
      classes={classes}
      preset={preset}
      {...props}
      editorProps={editorProps}
    >{children}</Hike>
  )
}

export default CodeHike
